export const questions = [
  "ACCEPTANCE: to be accepted as I am",
  "ACCURACY: to be correct in my opinions and beliefs",
  "ACHIEVEMENT: to have important accomplishments",
  "ADVENTURE: to have new and exciting experiences",
  "ART: to appreciate or express myself in art",
  "AUTHORITY: to be in charge of others",
  "BEAUTY: to appreciate beauty around me",
  "ATTRACTIVENESS: to be physically attractive",
  "AUTONOMY: to be self-determined and independent",
  "BELONGING: to have a sense of belonging, being part of",
  "CARING: to take care of others",
  "COMFORT: to have a pleasant and comfortable life",
  "COMPASSION: to feel and act on concern for others",
  "COMPROMISE: to be willing to give and take in reaching agreements",
  "COOPERATION: to work collaboratively with others",
  "CHALLENGE: to take on difficult tasks and problems",
  "COMMITMENT: to make enduring, meaningful commitments",
  "COMPLEXITY: to embrace the intricacies of life",
  "CONTRIBUTION: to make a lasting contribution in the world",
  "COURAGE: to be brave and strong in the face of adversity",
  "COURTESY:to be considerate and polite toward others", 
  "CURIOSITY: to seek out, experience, and learn new things",
  "DILIGENCE: to be thorough and conscientious in whatever I do",
  "ECOLOGY: to live in harmony with the environment",
  "FAITHFULNESS: to be loyal and true in relationships",
  "CREATIVITY: to create new things or ideas","DEPENDABILITY: to be reliable and trustworthy",
  "DUTY: to carry out my duties and obligations",
  "EXCITEMENT: to have a life full of thrills and stimulation",
  "FAME: to be known and recognized",
  "FAMILY: to have a happy, loving family",
  "FITNESS: to be physically fit and strong",
  "FLEXIBILITY: to adjust to new circumstances easily",
  "FORGIVENESS: to be forgiving of others",
  "FREEDOM: to be free from undue restrictions and limitations",
  "FRIENDSHIP: to have close, supportive friends",
  "FUN: to play and have fun",
  "GENEROSITY: to give what I have to others",
  "GENUINENESS: to act in a manner that is true to who I am",
  "GOD’S WILL: to seek and obey the will of God",
  "GRATITUDE: to be thankful and appreciative", 
  "GROWTH: to keep changing and growing",
  "HEALTH: to be physically well and healthy",
  "HONESTY: to be honest and truthful",
  "HOPE: to maintain a positive and optimistic outlook",
  "HUMILITY: to be modest and unassuming",
  "HUMOR: to see the humorous side of myself and the world",
  "IMAGINATION: to have dreams and see possibilities",
  "INDEPENDENCE: to be free from depending on others",
  "INDUSTRY: to work hard and well at my life tasks",
  "INNER PEACE: to experience personal peace",
  "INTEGRITY: to live my daily life in a way that is consistent with my values",
  "INTELLIGENCE: to keep my mind sharp and active",
  "JUSTICE: to promote fair and equal treatment for all",
  "LEADERSHIP: to inspire and guide others",
  "LOVED: to be loved by those close to me",
  "INTIMACY: to share my innermost experiences with others",
  "KNOWLEDGE: to learn and contribute valuable knowledge",
  "LEISURE: to take time to relax and enjoy",
  "LOVING: to give love to others",
  "MASTERY: to be competent in my everyday activities",
  "MINDFULNESS: to live conscious and mindful of the present moment",
  "MODERATION: to avoid excesses and find a middle ground",
  "MUSIC: to enjoy or express myself in music",
  "NOVELTY: to have a life full of change and variety",
  "OPENNESS: to be open to new experiences, ideas, and options",
  "MONOGAMY: to have one close, loving relationship",
  "NON-CONFORMITY: to question and challenge authority and norms",
  "NURTURANCE: to encourage and support others",
  "ORDER: to have a life that is well-ordered and organized",
  "PASSION: to have deep feelings about ideas, activities, or people",
  "PLEASURE: to feel good",
  "POWER: to have control over others",
  "PROTECT: to protect and keep safe those I love",
  "PURPOSE: to have meaning and direction in my life",
  "PATRIOTISM: to love, serve, and protect my country",
  "POPULARITY: to be well-liked by many people",
  "PRACTICALITY: to focus on what is practical, prudent, and sensible",
  "PROVIDE: to provide for and take care of my family",
  "RATIONALITY: to be guided by reason, logic, and evidence",
  "REALISM: to see and act realistically and practically",
  "RESPONSIBILITY: to make and carry out responsible decisions",
  "RISK: to take risks and chances",
  "ROMANCE: to have intense, exciting love in my life",
  "SAFETY: to be safe and secure",
  "SELF-ACCEPTANCE: to accept myself as I am",
  "SELF-CONTROL: to be disciplined in my own actions",
  "SELF-ESTEEM: to feel good about myself",
  "SELF-KNOWLEDGE: to have a deep and honest understanding of myself",
  "SERVICE: to be helpful and of service to others",
  "SEXUALITY: to have an active and satisfying sex life",
  "SOLITUDE: to have time and space where I can be apart from others",
  "STABILITY: to have a life that stays fairly consistent",
  "TRADITION: to follow respected patterns of the past",
  "WEALTH: to have plenty of money",
  "SIMPLICITY: to live life simply, with minimal needs",
  "SPIRITUALITY: to grow and mature spiritually",
  "TOLERANCE: to accept and respect those who differ from me",
  "VIRTUE: to live a morally pure and excellent life",
  "WORLD PEACE: to work to promote peace in the world"
]
console.log(questions.length)